import { createBrowserRouter } from "react-router-dom";
import { AppInner } from "./App";
import { Home } from "../features/home/Home";
import { LoginForm } from "../features/login/LoginForm";
import { BookList } from "../features/books/BookList";
import { BookRead } from "../features/books/read/BookRead";
import { BookEdit } from "../features/books/edit/BookEdit";
import { LanguageList } from "../features/languages/LanguageList";
import { AbbreviationList } from "../features/abbreviations/AbbreviationList";
import { DictLinkList } from "../features/dict_links/DictLinkList";
import { BookPreview } from "../features/books/read/BookPreview";
import { UserRegistrationForm } from "../features/user/UserRegistrationForm";
import { UserActivationForm } from "../features/user/UserActivationForm";
import { PasswordResetRequest } from "../features/user/PasswordResetRequest";
import { PasswordReset } from "../features/user/PasswordReset";
import { ResendActivationEmail } from "../features/user/ResendActivationEmail";
import { UserSettings } from "../features/user/UserSettings";
import { ArbitraryText } from "../features/arbitrary_text/ArbitraryText";

/**
 * Routes determine what page is shown by the corresponding URL.
 */
const routes = 
[
    {
        path: "/",
        /** The parent element inside which the routes are shown.
         * Or rather, they're shown in its child called Outlet. */
        element: <AppInner />,
        children: 
        [
            {path: "", element: <Home />},
            {path: "user/register", element: <UserRegistrationForm />},
            {path: "user/resend-activation-email", element: <ResendActivationEmail />},
            {path: "user/activate/", element: <UserActivationForm />},
            {path: "user/password-reset-request", element: <PasswordResetRequest />},
            {path: "user/password-reset/", element: <PasswordReset />},
            {path: "user/settings", element: <UserSettings />},
            {path: "loginform", element: <LoginForm />},
            {path: "books", element: <BookList />},
            {path: "book/read/", element: <BookRead />},
            {path: "book/edit/", element: <BookEdit />},
            {path: "book/preview", element: <BookPreview />},
            {path: "languages", element: <LanguageList />},
            {path: "abbreviations", element: <AbbreviationList />},
            {path: "dictlinks", element: <DictLinkList />},
            {path: "arbitrarytext", element: <ArbitraryText />},
        ]
    },
];

export const browserRouter = createBrowserRouter(routes);